import React from 'react';
import { Badge, Form, Switch } from 'antd';

/**
 * NMU-527: the สถานะ toggle, with the word beside it.
 *
 * On its own the toggle communicates through colour and knob position alone,
 * which asks an editor to remember which side means published. The label is
 * antd's own Badge in the colours the listing tables already use for this field
 * ({@link ONLINE_COLOR} / {@link OFFLINE_COLOR}), so a dialog and its table read
 * as the same thing rather than two conventions for one value.
 *
 * A component rather than a copied block: NMU-523 added this to the Splash Page
 * dialog and NMU-527 to the banner dialog, and the same toggle sits in a dozen
 * more. One of them drifting is how "Online" ends up green in one form and grey
 * in the next.
 *
 * The label follows the toggle through a `shouldUpdate` scoped to this field, so
 * the Form stays the single source of truth for the value and only the label
 * re-renders. Mirroring the toggle into component state is how a label ends up
 * disagreeing with what is actually saved.
 */

/** The listing tables' own colours — see the สถานะ column render. */
export const ONLINE_COLOR = '#4A9A0F';
export const OFFLINE_COLOR = '#CBCACA';

const StatusSwitchFormItem = ({ label = 'สถานะ', name = 'status', onLabel = 'Online', offLabel = 'Offline', ...props }) => (
    <Form.Item label={label} className="mb-3" {...props}>
        <div className="d-flex align-items-center">
            <Form.Item name={name} valuePropName="checked" noStyle>
                <Switch />
            </Form.Item>
            <Form.Item noStyle shouldUpdate={(prev, curr) => prev[name] !== curr[name]}>
                {({ getFieldValue }) => (
                    <Badge
                        className="ms-3 text-nowrap"
                        color={getFieldValue(name) ? ONLINE_COLOR : OFFLINE_COLOR}
                        text={getFieldValue(name) ? onLabel : offLabel}
                    />
                )}
            </Form.Item>
        </div>
    </Form.Item>
);

export default StatusSwitchFormItem;
